import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { App } from '@df/core/app';
import { Client } from '@df/core/service/client';
import { AdvancedCommerceListingFiltersAttributeComponentDef } from '@df/module-advanced-commerce';
import { FacetUrlModule } from '@df/module-facet-url/facet-url.module';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SwatchComponent } from 'projects/app-default/src/app/catalog/attribute/swatch/swatch.component';
import { NListing } from 'projects/app-default/src/app/catalog/ui/listing/product-listing.interface';
import { ExpandableComponent } from 'projects/app-default/src/app/ui/display/expandable/expandable.component';

@Component({
    selector: 'ac-filter-attribute-option',
    templateUrl: '../../../../catalog/ui/listing/filter/filter-attribute-option.html',
    standalone: true,
    imports: [ExpandableComponent, NgClass, GridModule, HrefComponent, FacetUrlModule, SwatchComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvancedCommerceFilterAttributeOptionComponent
    extends AdvancedCommerceListingFiltersAttributeComponentDef
    implements NListing.IFilterAttr
{
    readonly client = inject(Client);
    readonly app = inject(App);

    optionsWithMatches = computed(() => {
        const filters = this.filter().options?.filter(option => !!option?.count);
        return filters && [...filters];
    });

    clear(event: Event, option: Catalog.IAttributeOption) {
        event.preventDefault();
        this.store.filtersResetSelection();
    }
    get zippyId() {
        return ['filter', this.filter().id];
    }
    getSelectedOptionsForFilter(lengthLimit = 20): string | undefined {
        const options = this.options
            ?.filter(option => option.selected)
            .map(i => i.label)
            .join(', ');
        return options && options.length > lengthLimit && options.indexOf(',', lengthLimit) !== -1
            ? options.slice(0, options.indexOf(',', lengthLimit)) + '...'
            : options;
    }

    get isDefaultOpen(): boolean {
        return false;
    }

    get label(): string | undefined {
        return this.filter().label;
    }

    get id(): string {
        return this.filter().id;
    }

    get isSwatch(): boolean {
        return !!this.filter().isSwatch;
    }

    get options() {
        return this.optionsWithMatches();
    }

    get hasAnyCurrentMatches(): boolean {
        return !!this.options?.filter(option => !!option?.count)?.length;
    }

    getCurrentMatchesCount(option): number {
        return option.count;
    }

    isSelected(option): boolean {
        return option.selected;
    }

    toggle(option): void {
        this.pickOption(option);
    }

    get sortedOptionsWithMatches() {
        return this.optionsWithMatches;
    }
}
